import React from 'react';
import { Link } from '@inertiajs/react';
import Layout from '../../../components/Layout.jsx';
import WebinarForm from './_Form.jsx';

export default function SuperadminWebinarsNew({ webinar, statuses, visibilities, instructors = [] }) {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto p-6 sm:p-8 space-y-6">
        <Link href="/superadmin/webinars" className="text-sm text-indigo-600 hover:text-indigo-700">← Back to webinars</Link>
        <h1 className="text-3xl font-bold tracking-tight text-gray-900">New webinar</h1>
        <WebinarForm
          webinar={webinar}
          statuses={statuses}
          visibilities={visibilities}
          instructors={instructors}
          hideStatus
          submitUrl="/superadmin/webinars"
          method="post"
          submitLabel="Create webinar"
        />
      </div>
    </Layout>
  );
}
